<template>
  <section class="hero is-fullheight faq-page">
    <PmNavbar />
    <div class="hero-body">
      <div class="container">
        <div class="columns is-multiline p-5">
          <div class="column is-12">
            <h1 class="mb-3 font-secondary font-28">FAQ – usein kysytyt kysymykset</h1>

            <h2 class="mb-3 font-secondary font-25">YLEISTÄ</h2>

            <h3 class="mt-5 font-secondary font-20">
              Voiko kuka tahansa ostaa Pyrollkaupasta?
            </h3>
            <p class="font-18">
              Pyrollkauppa on yritysasiakkaille, eli kaikki yritykset ja yhteisöt, joilla on Y-tunnus voivat tilata Pyrollkaupasta
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Miten ostokset maksetaan?
            </h3>
            <p class="font-18">
  	      Verkkokauppa käyttää maksunvälittäjänä Paytrailia. Paytrailin kautta maksaminen onnistuu tilisiirtona, korttimaksuna tai laskulla helposti ja turvallisesti.
            </p>

            <h3 class="mt-5 font-secondary font-20">Miten nopeasti tuotteet toimitetaan?</h3>
            <p class="font-18">
              Varastotuotteet lähetämme 2 – 3 päivän sisällä tilauksesta, saat sähköpostiin tiedon kun tilauksesi on
              matkalla. Mikäli jokin varastotuote on loppunut, asiakaspalvelumme ottaa yhteyttä.
            </p>
            <p class="font-18">
              Omilla painatuksilla olevien tuotteiden toimitusajat vaihtelevat tuotteittain, kupit ja lautaset n. 2 – 3
              viikkoa, muissa tuotteissa vahvistamme tapauskohtaisesti toimitusajan
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Miten tuotteet toimitetaan?
            </h3>
            <p class="font-18">
              Tuotteet toimitetaan yleensä Schenker – DSV:n rahtina, mutta voimme käyttää muitakin rahdinkuljettajia.
              Tuotteet toimitetaan annettuun toimitusosoitteeseen katutasolle.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Voiko tuotteet noutaa itse?
            </h3>
            <p class="font-18">
              Tuotteet voi noutaa, mutta ilmoita siitä jo tilausvaiheessa, jolloin asiakaspalvelumme sopii noutoajan
              kanssasi. Tilausvahvisteeseen tulee automaattisesti kuitenkin toimituskulu, mutta jos noudat poistamme
              laskusta rahtikulut.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Voinko muuttaa tai peruuttaa tilaukseni?
            </h3>
            <p class="font-18">
              Jos tilaus ei ole vielä siirtynyt käsittelyyn, asiakaspalvelu voi yleensä tehdä muutoksia tai peruutuksen.
              Ota yhteyttä mahdollisimman pian. Jo toimitettua tilausta ei voi peruuttaa.
            </p>

            <h3 class="mt-5 font-secondary font-20">Mitä teen, jos saan väärän tai viallisena saapuneen tuotteen?</h3>
            <p class="font-18">
              Ota yhteyttä asiakaspalveluun ja liitä mukaan tilausnumero sekä tarvittaessa kuva tuotteesta.
              He ohjeistavat palautuksen tai vaihdon.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Mitä teen, jos en löydä sopivaa pakkausta?
            </h3>
            <p class="font-18">
              Pyrollkaupan asiakaspalvelu auttaa löytämään oikean tuotteen tai suunnittelemaan täysin uuden ratkaisun.
              Heiltä voi kysyä myös materiaalivalinnoista ja painatusmahdollisuuksista.
            </p>

            <h3 class="mt-5 font-secondary font-20">Mitä tarkoittaa, että tuotteet ovat Avainlippu merkittyjä?</h3>
            <p class="font-18">
              Avainlippu kertoo, että tuote on valmistettu Suomessa ja tukee kotimaista työtä. Pyrollin pakkaukset ovat kotimaista tuotantoa.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Voinko tilata näytekappaleita?
            </h3>
            <p class="font-18">
              Kyllä, asiakaspalvelu voi lähettää näytteitä useista tuotteista ennen isompaa tilausta.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Mitä teen, jos tarvitsen täysin oman mitan?
            </h3>
            <p class="font-18">
              Pyroll valmistaa myös täysin räätälöityjä pakkauksia asiakkaan mitoilla, materiaaleilla ja painatuksilla.
              Ota yhteyttä asiakaspalveluun niin räätälöidään sinulle sopivin pakkaus.
            </p>

            <h2 class="mt-5 mb-3 font-secondary font-25">TUOTTEET</h2>

            <h3 class="mt-5 font-secondary font-20">
              Ovatko kaikki verkkokaupan tuotteet hyväksyttyjä elintarvikekäyttöön?
            </h3>
            <p class="mb-5 font-18">
              Kyllä, kaikki elintarvikepakkaukset ovat turvallisia elintarvikkeiden pakkaamiseen ja tarjoiluun ohjeiden
              mukaisesti käytettynä. Tuotteita valmistavilla tehtailla on laatu- ja elintarviketurvallisuussertifikaatit.
              Voit huoletta käyttää Pyrollkaupan tuotteita elintarvikkeiden tarjoiluun ja pakkaamiseen.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Saako tuotteista elintarvikekelpoisuustodistukset?
            </h3>
            <p class="mb-5 font-18">
              Kyllä, kaikista elintarvikekäyttöön tarkoitetuista tuotteista on saatavissa vastaavuustodistukset.
              Jos tarvitset todistusta, ota yhteys verkkokaupan asiakaspalveluun
              <a href="mailto:asiakaspalvelu@packagemedia.fi">asiakaspalvelu@packagemedia.fi</a>
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Missä tuotteet valmistetaan?
            </h3>
            <p class="mb-5 font-18">
              Pääosa tuotteista valmistetaan Pyrollin tehtailla Suomessa.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Kestävätkö leivosrasiat rasvaa?
            </h3>
            <p class="mb-5 font-18">
              Verkkokaupan leivosrasiat ovat barrier-pinnoitettuja. Barrier-päällystys antaa kevyen rasvan ja
              kosteudenkeston, eli leivosrasiat kestävät rasvaa lyhytaikaisesti ja ne on tarkoitettu leivonnaisten
              lyhytaikaiseen säilytykseen.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Soveltuvatko kaikki muovipussit pakastamiseen?
            </h3>
            <p class="mb-5 font-18">
              Pusseista pakastamiseen soveltuvat PE-pussit, joita myös annostelupakkauksissa myytävät pussit ovat.
              PP-pussit eivät kestä pakastamista.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Voiko pusseihin painattaa oman logon?
            </h3>
            <p class="mb-5 font-18">
              Kyllä. Paperipusseihin voidaan tehdä yksilöllinen painatus yrityksen väreillä ja logolla.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Mitä painotekniikoita pakkausten painamiseen käytetään?
            </h3>
            <p class="mb-5 font-18">
              Kupit painetaan digitaalisesti, rasiat ja kotelot painetaan digitaalisesti tai offsetilla ja pussit
              flexopainatuksella.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Miten tuotteet kierrätetään
            </h3>
            <p class="mb-5 font-18">
              Kunkin tuotteen kierrätysohje on tuotetiedoissa. Yleisohjeena muovipussit kierrätetään muvijätteenä,
              kartonki ja pahvi kartonkijätteenä, paperipussit, mukaan lukien ikkunalliset versiot ja paperikassit,
              kuuluvat kartonginkeräykseen, sillä ne ovat kuitupakkauksia, eivät paperia. Puhtaat ja kuivat paperipussit
              (kuten jauho- tai leipäpussit) voi hyödyntää biojätteen keräyksessä. Likaiset, rasvaiset tai kastuneet
              pussit lajitellaan poltettavaan jätteeseen (sekajäte).
            </p>

            <h2 class="mt-5 mb-3 font-secondary font-25">KUPIT</h2>

            <h3 class="mt-5 font-secondary font-20">
              Miten käytetyt kupit voi kierrättää?
            </h3>
            <p class="mb-5 font-18">
              Kupit kierrätetään kartonkijätteenä.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Soveltuvatko kupit sekä kylmille että kuumille juomille?
            </h3>
            <p class="mb-5 font-18">
              Kyllä soveltuvat.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Kestävätkö kupit alkoholijuomia?
            </h3>
            <p class="mb-5 font-18">
              Kupit kestävät mietoja enintään noin 10 % vol. alkoholijuomia rajoitetun ajan.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Mikä on toimitusaika?
            </h3>
            <p class="mb-5 font-18">
              Omilla painatuksilla olevat tuotteet toimitetaan noin 10–15 arkipäivässä.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Missä tuotteet valmistetaan?
            </h3>
            <p class="mb-5 font-18">
              Kupit ja niiden raaka-aineet valmistetaan kokonaan Suomessa.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              En osaa suunnitella kuppia, voitteko auttaa?
            </h3>
            <p class="mb-5 font-18">
              Kyllä, ota yhteyttä asiakaspalveluumme niin ammattilaisemme suunnittelevat sinulle mieleisesi kupin. Voit
              lähettää sähköpostia: <a href="mailto:asiakaspalvelu@packagemedia.fi">asiakaspalvelu@packagemedia.fi</a>
              tai jättää aineistot ohjeineen verkkokaupassa meille muokattavaksi
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Ovatko kupit turvallisia käyttää?
            </h3>
            <p class="mb-5 font-18">
              Kyllä, kuppien kaikki materiaalit ovat elintarvikekelpoisia ja kuppien valmistuksessa noudatetaan tiukkoja
              hygieniaohjeita. Kuppeja valmistavalla tehtaalla on ISO 22000 elintarviketurvallisuussertifikaatti sekä
              auditoidut laatujärjestelmät.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Pyrollkaupan kupit ovat vesidispersiopinnoitettuja, mitä se tarkoittaa?
            </h3>
            <p class="mb-5 font-18">
              Kaikki kartonkikupit tarvitsevat jonkinlaisen pinnoitteen, jolla varmistetaan kuppien valmistuksessa
              niiden saumautuvuus ja toisaalta nesteenpitävyys. Vaihtoehtoja pinnoitteeksi ovat muovi (PE =polyeteeni)
              tai biomuovi (PLA = poly lactic acid), joka on yleensä sokeriruokopohjainen muovi. Meidän käyttämässämme
              kuppikartongissa saumautuvuus ja nesteenpitävyys saadaan aikaan vesipohjaisella dispersiopinnoitteella.
              Vesidispersiopinnoite sisältää kuitenkin polymeerejä, jonka vuoksi tuotteeseen on EU:n SUP-direktiivin
              mukaisesti lisättävä tuotteen sisältämästä muovista kertova kilpikonnalogo, vaikka kupista ei pystykään
              erottamaan erillistä muovikerrosta.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Mistä saan kilpikonnalogon painatusaineistoon?
            </h3>
            <p class="mb-5 font-18">
              3D-suunnitteluohjelmamme lisää sen automaattisesti oikean kokoisena kupin alareunaan, josta voit siirtää
              sitä itse, se näkyy esikatselussa ja suunnittelupohjassa. Jos kuitenkin teen aineiston kokonaan itse ja
              haluat lähettää sen valmiina, ota yhteyttä asiakaspalveluumme niin lähetämme kilpikonnalogon sisältävän
              tiedoston.
            </p>

            <h3 class="mt-5 font-secondary font-20">
              Ovatko vesidispersiopinnoitetut kupit muovittomia?
            </h3>
            <p class="mb-5 font-18">
              Markkinoilla vesidispersiopinnoitettuja mukeja kutsutaan joskus "muovittomiksi". Huomioitavaa kuitenkin on,
              että pinnoite voi silti sisältää akryyli- tai polystyreenihiukkasia, vaikka ne eivät muodostakaan yhtenäistä
              kalvoa. Siksi se on ekologinen edistysaskel, mutta ei täysin "vapaa" kaikista polymeereistä, jonka vuoksi
              emme markkinoi sitä täysin muovittomana vaihtoehtona. Muovipitoisuus on kuitenkin huomattavasti pienempi
              kuin varsinaisissa muovipäällysteisissä materiaaleissa.
            </p>
          </div>
        </div>
        <div class="columns p-5" style="margin-top: 15px;">
          <div class="column is-4 is-flex is-flex-direction-column is-justify-content-start">
            <div class="img-container is-flex is-justify-content-center is-align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">
                <path class="cstm-icon" id="recycle-solid" d="M28.838,40.922A2.5,2.5,0,0,1,25.077,43.6l-6.365-3.977L10.764,52.346A5.009,5.009,0,0,0,15,60h8.123A1.875,1.875,0,0,1,25,61.874v6.25A1.875,1.875,0,0,1,23.125,70H15.018A15.01,15.01,0,0,1,2.3,47.049l7.941-12.717L3.876,30.356A2.5,2.5,0,0,1,4.638,25.8l17.224-3.977a2.5,2.5,0,0,1,3,1.873l3.977,17.224Zm15.4-28.58,6.451,10.324-6.366,3.978a2.5,2.5,0,0,0,.762,4.556l17.224,3.977a2.5,2.5,0,0,0,3-1.873l3.977-17.224A2.5,2.5,0,0,0,65.525,13.4l-6.357,3.972L52.72,7.043a15.008,15.008,0,0,0-25.44,0l-2.807,4.495a1.875,1.875,0,0,0,.6,2.583l5.3,3.312a1.875,1.875,0,0,0,2.584-.6l2.806-4.491a5.005,5.005,0,0,1,8.478,0ZM77.7,47.049l-4.3-6.885a1.875,1.875,0,0,0-2.584-.6l-5.291,3.306a1.875,1.875,0,0,0-.6,2.584l4.307,6.892A5.009,5.009,0,0,1,65,60H50V52.5a2.5,2.5,0,0,0-4.268-1.768l-12.5,12.5a2.5,2.5,0,0,0,0,3.535l12.5,12.5A2.5,2.5,0,0,0,50,77.5V70H64.981A15.009,15.009,0,0,0,77.7,47.049Z" transform="translate(0 0)" fill="#aaba31"/>
              </svg>
            </div>
            <p class="has-text-centered font-18 pb-4">
              {{ this.$t("message.pages.landing.imageOneText") }}
            </p>
          </div>
          <div class="column is-4 is-flex is-flex-direction-column is-justify-content-end">
            <div class="img-container is-flex is-justify-content-center is-align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="60" height="80" viewBox="0 0 60 80">
                <path class="cstm-icon" id="map-marker-alt-solid" d="M26.917,78.386C4.214,45.474,0,42.1,0,30a30,30,0,0,1,60,0c0,12.1-4.214,15.474-26.917,48.386a3.752,3.752,0,0,1-6.166,0ZM30,42.5A12.5,12.5,0,1,0,17.5,30,12.5,12.5,0,0,0,30,42.5Z" fill="#aaba31"/>
              </svg>
            </div>
            <p class="has-text-centered font-18 pb-4">
              {{ this.$t("message.pages.landing.imageTwoText") }}
            </p>
          </div>
          <div class="column is-4 is-flex is-flex-direction-column is-justify-content-start">
            <div class="img-container is-flex is-justify-content-center is-align-items-center">
              <!--img class="cstm-icon" src="../assets/img/balance-scale-solid.svg" /-->
              <svg xmlns="http://www.w3.org/2000/svg" width="100" height="80" viewBox="0 0 100 80">
                <path class="cstm-icon" id="balance-scale-solid" d="M40,52.5h0c0-2.528.209-1.364-13.289-28.361a7.506,7.506,0,0,0-13.417,0C-.322,51.367,0,50.052,0,52.5H0C0,59.4,8.955,65,20,65S40,59.4,40,52.5Zm-20-25L31.25,50H8.75Zm80,25c0-2.528.209-1.364-13.289-28.361a7.506,7.506,0,0,0-13.417,0C59.678,51.367,60,50.052,60,52.5h0C60,59.4,68.955,65,80,65s20-5.6,20-12.5ZM68.75,50,80,27.5,91.25,50ZM82.5,70H55V23.945A12.51,12.51,0,0,0,62.248,15H82.5A2.5,2.5,0,0,0,85,12.5v-5A2.5,2.5,0,0,0,82.5,5H59.944A12.388,12.388,0,0,0,40.056,5H17.5A2.5,2.5,0,0,0,15,7.5v5A2.5,2.5,0,0,0,17.5,15H37.752A12.509,12.509,0,0,0,45,23.945V70H17.5A2.5,2.5,0,0,0,15,72.5v5A2.5,2.5,0,0,0,17.5,80h65A2.5,2.5,0,0,0,85,77.5v-5A2.5,2.5,0,0,0,82.5,70Z" fill="#aaba31"/>
              </svg>
            </div>
            <p class="has-text-centered font-18 pb-4">
              {{ this.$t("message.pages.landing.imageThreeText") }}
            </p>
          </div>                    
        </div>           
      </div>
    </div>
    <PmFooter />
  </section>  
</template>

<script>
import PmNavbar from "../components/PmNavbar";
import PmFooter from "../components/PmFooter";

export default {
  name: "PrivacyPolicyPage",
  components: {
    PmNavbar,
    PmFooter,
  },
  data() {
    return {}
  },
  methods: {},
  mounted() {},
  computed: {},
}
</script>

<style scoped lang="scss">
@use '../assets/sass/variables' as *;
.faq-page {
  .img-container {
    height: 150px;
    flex-grow: 1;
  }
  .cstm-icon {
    fill: $pyroll-violet;
  }  
}
</style>
